import { FC, PropsWithChildren, useRef } from 'react';

import { useApplicationConfig } from '@bonusly/application';

import { useChannelStore } from '../hooks/use-channel-store';

export const ChannelProvider: FC<PropsWithChildren> = ({ children }) => {
	const wsConnectUrl = useApplicationConfig('recognizeCable');
	const initialize = useChannelStore((state) => state.initialize);
	const initRef = useRef(false);

	// This is controlled via a ref as we only ever want a single channel to be created and there
	// is no available teardown
	if (!initRef.current) {
		initialize(wsConnectUrl);
		initRef.current = true;
	}

	return <>{children}</>;
};
